import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_cookieuniversalnuxt_94943626 from 'nuxt_plugin_cookieuniversalnuxt_94943626' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_apollomodule_48f1b3de from 'nuxt_plugin_apollomodule_48f1b3de' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_5db16f45 from 'nuxt_plugin_axios_5db16f45' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_58481c60 from 'nuxt_plugin_deviceplugin_58481c60' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_moment_67280af3 from 'nuxt_plugin_moment_67280af3' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axiosServerLogging_2011728c from 'nuxt_plugin_axiosServerLogging_2011728c' // Source: ../plugins/axiosServerLogging (mode: 'server')
import nuxt_plugin_recaptcha_78653d1a from 'nuxt_plugin_recaptcha_78653d1a' // Source: ../plugins/recaptcha (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_auth_92710cc8 from 'nuxt_plugin_auth_92710cc8' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_global_2c8b7297 from 'nuxt_plugin_global_2c8b7297' // Source: ../plugins/global (mode: 'all')
import nuxt_plugin_loader_35379f07 from 'nuxt_plugin_loader_35379f07' // Source: ../plugins/loader (mode: 'all')
import nuxt_plugin_observe_09837eb0 from 'nuxt_plugin_observe_09837eb0' // Source: ../plugins/observe (mode: 'all')
import nuxt_plugin_toaster_18f524a0 from 'nuxt_plugin_toaster_18f524a0' // Source: ../plugins/toaster (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_vueselect_3ecdefd2 from 'nuxt_plugin_vueselect_3ecdefd2' // Source: ../plugins/vue-select (mode: 'all')
import nuxt_plugin_vuetelinput_350602c6 from 'nuxt_plugin_vuetelinput_350602c6' // Source: ../plugins/vue-tel-input (mode: 'client')
import nuxt_plugin_persistedState_15475dd2 from 'nuxt_plugin_persistedState_15475dd2' // Source: ../plugins/persistedState (mode: 'all')
import nuxt_plugin_setup_231e1d09 from 'nuxt_plugin_setup_231e1d09' // Source: ../plugins/setup (mode: 'all')
import nuxt_plugin_ipAddress_01f31959 from 'nuxt_plugin_ipAddress_01f31959' // Source: ../plugins/ipAddress (mode: 'all')
import nuxt_plugin_datadog_989e2644 from 'nuxt_plugin_datadog_989e2644' // Source: ../plugins/datadog (mode: 'client')
import nuxt_plugin_clientsideerrorcollectors_534b8a57 from 'nuxt_plugin_clientsideerrorcollectors_534b8a57' // Source: ../plugins/clientside-errorcollectors (mode: 'client')
import nuxt_plugin_everflow_68887540 from 'nuxt_plugin_everflow_68887540' // Source: ../plugins/everflow (mode: 'client')
import nuxt_plugin_modal_22cddd39 from 'nuxt_plugin_modal_22cddd39' // Source: ../plugins/modal (mode: 'client')
import nuxt_plugin_custompageload_1052b008 from 'nuxt_plugin_custompageload_1052b008' // Source: ../plugins/custom-page-load (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"ON THAT ASS","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"On That Ass"},{"name":"apple-mobile-web-app-title","content":"ON THAT ASS"},{"name":"application-name","content":"ON THAT ASS"},{"name":"msapplication-TileColor","content":"#000"},{"name":"google-site-verification","content":"vdGsvAS9AQncEuN-aejtpepsAlzE6CV_nqAH3pSJut4"},{"name":"theme-color","content":"#000"},{"name":"p:domain_verify","content":"569709daec57953bab8588c950d797a1"},{"hid":"og:title","name":"og:title","property":"og:title","content":"ON THAT ASS"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Premium Boxershort Membership"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fonthatass.com\u002Fimages\u002Fdesign\u002Fursa\u002Fcampaign\u002Fursa-men-originals.webp"},{"name":"fb:app_id","content":"1022972678582728"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.webp"},{"rel":"icon","sizes":"32x32","href":"\u002Ffavicon-32x32.webp"},{"rel":"icon","sizes":"16x16","href":"\u002Ffavicon-16x16.webp"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#000"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap","media":"print","onload":"this.media='all'"},{"rel":"preconnect","href":"https:\u002F\u002Fdev.visualwebsiteoptimizer.com"}],"script":[{"hid":"gtm","innerHTML":"window.dataLayer = window.dataLayer || [];","type":"text\u002Fjavascript"},{"hid":"gtm-script","innerHTML":"!function(){\"use strict\";function l(e){for(var t=e,r=0,n=document.cookie.split(\";\");r\u003Cn.length;r++){var o=n[r].split(\"=\");if(o[0].trim()===t)return o[1]}}function s(e){return localStorage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=document,r=\"script\",n=\"dataLayer\",o=\"https:\u002F\u002Fgtm.onthatass.com\",a=\"\",i=\"8sgytmxskyzux\",c=\"8t=aWQ9R1RNLU45Njg1Rw%3D%3D&apiKey=9ca3fd1e\",g=\"stapeUserId\",v=\"\",E=\"\",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp(\"Version\u002F([0-9._]+)(.*Mobile)?.*Safari.*\").exec(m)))&&16.4\u003C=parseFloat(m[1]),f=\"stapeUserId\"===g,I=d&&!f?function(e,t,r){void 0===t&&(t=\"\");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a\u003Ci.length;a++){var c=i[a],c=r?o(c,r):o(c);if(c)return c}else console.warn(\"invalid uid source\",e)}(g,v,E):void 0;d=d&&(!!I||f)}catch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({\"gtm.start\":(new Date).getTime(),event:\"gtm.js\"}),t.getElementsByTagName(r)[0]),v=I?\"&bi=\"+encodeURIComponent(I):\"\",E=t.createElement(r),f=(d&&(i=8\u003Ci.length?i.replace(\u002F([a-z]{8}$)\u002F,\"kp$1\"):\"kp\"+i),!d&&a?a:o);E.async=!0,E.src=f+\"\u002F\"+i+\".js?\"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();","type":"text\u002Fjavascript"},{"id":"vwoCode","innerHTML":"window._vwo_code || (function() {\n  var account_id=1038910,\n  version=2.1,\n  settings_tolerance=2000,\n  hide_element='body',\n  hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',\n  \u002F* DO NOT EDIT BELOW THIS LINE *\u002F\n  f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https:\u002F\u002Fdev.visualwebsiteoptimizer.com\u002Fee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text\u002Fjavascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()\u003Ee.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')\u003E-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text\u002Fcss');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https:\u002F\u002Fdev.visualwebsiteoptimizer.com\u002Fj.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();","type":"text\u002Fjavascript"}],"__dangerouslyDisableSanitizers":["script","noscript"],"noscript":[{"hid":"gtm-noscript","innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fgtm.onthatass.com\u002Fns.html?id=GTM-N9685G\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"\u003E\u003C\u002Fiframe\u003E","body":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_cookieuniversalnuxt_94943626 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_94943626(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_48f1b3de === 'function') {
    await nuxt_plugin_apollomodule_48f1b3de(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5db16f45 === 'function') {
    await nuxt_plugin_axios_5db16f45(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_58481c60 === 'function') {
    await nuxt_plugin_deviceplugin_58481c60(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_67280af3 === 'function') {
    await nuxt_plugin_moment_67280af3(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_axiosServerLogging_2011728c === 'function') {
    await nuxt_plugin_axiosServerLogging_2011728c(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_78653d1a === 'function') {
    await nuxt_plugin_recaptcha_78653d1a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_92710cc8 === 'function') {
    await nuxt_plugin_auth_92710cc8(app.context, inject)
  }

  if (typeof nuxt_plugin_global_2c8b7297 === 'function') {
    await nuxt_plugin_global_2c8b7297(app.context, inject)
  }

  if (typeof nuxt_plugin_loader_35379f07 === 'function') {
    await nuxt_plugin_loader_35379f07(app.context, inject)
  }

  if (typeof nuxt_plugin_observe_09837eb0 === 'function') {
    await nuxt_plugin_observe_09837eb0(app.context, inject)
  }

  if (typeof nuxt_plugin_toaster_18f524a0 === 'function') {
    await nuxt_plugin_toaster_18f524a0(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_vueselect_3ecdefd2 === 'function') {
    await nuxt_plugin_vueselect_3ecdefd2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinput_350602c6 === 'function') {
    await nuxt_plugin_vuetelinput_350602c6(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedState_15475dd2 === 'function') {
    await nuxt_plugin_persistedState_15475dd2(app.context, inject)
  }

  if (typeof nuxt_plugin_setup_231e1d09 === 'function') {
    await nuxt_plugin_setup_231e1d09(app.context, inject)
  }

  if (typeof nuxt_plugin_ipAddress_01f31959 === 'function') {
    await nuxt_plugin_ipAddress_01f31959(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadog_989e2644 === 'function') {
    await nuxt_plugin_datadog_989e2644(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientsideerrorcollectors_534b8a57 === 'function') {
    await nuxt_plugin_clientsideerrorcollectors_534b8a57(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_everflow_68887540 === 'function') {
    await nuxt_plugin_everflow_68887540(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_modal_22cddd39 === 'function') {
    await nuxt_plugin_modal_22cddd39(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_custompageload_1052b008 === 'function') {
    await nuxt_plugin_custompageload_1052b008(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
